import { render, staticRenderFns } from "./FullPlan.vue?vue&type=template&id=72f18474&scoped=true"
import script from "./FullPlan.vue?vue&type=script&lang=js"
export * from "./FullPlan.vue?vue&type=script&lang=js"
import style0 from "./FullPlan.vue?vue&type=style&index=0&id=72f18474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f18474",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QImg,QCard,QCardSection});
